import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getRedirectUrlSS } from 'utils/helpers';

const Redirect = () => {
  if (EMBEDDED) {
    return (
      <div className="page-content">
        <div className="container txt-center">
          <p>
            <FormattedMessage id="redirect.info.text" />
          </p>
          <a href={getRedirectUrlSS()} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="redirect.info.ss_link" />
          </a>
        </div>
      </div>
    );
  }

  return (
    <h1 className="txt-center">
      <FormattedMessage id="redirect.info" />
    </h1>
  );
};

export default Redirect;
